import { Clock } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const humanDur = (sec) => {
  if (sec == null || sec < 0) return null;
  sec = Math.round(sec);
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  if (h < 24) return rm ? `${h}h ${rm}m` : `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}g ${h % 24}h`;
};

const durBetween = (a, b) => {
  if (!a || !b) return null;
  try { return humanDur((new Date(b) - new Date(a)) / 1000); } catch { return null; }
};

// Timeline processo: acquisto -> preso in carico -> consegnato -> validato
export default function Timeline({ a, compact = false }) {
  const fuori = a.origine === "fuori_mercato";
  const steps = [
    { key: "acquistato", label: "Acquistato", at: a.created_at, who: a.created_by_name },
    ...(fuori ? [] : [{ key: "assegnato", label: "Assegnato al picker", at: a.assigned_at, who: a.picker?.name || a.assigned_by_name }]),
    ...(fuori ? [] : [{ key: "visto", label: "Visto dal picker", at: a.seen_at, who: a.picker?.name }]),
    ...(fuori ? [] : [{ key: "preso", label: "Preso in carico", at: a.taken_at, who: a.taken_by_name || a.picker?.name }]),
    { key: "consegnato", label: fuori ? "Portato al banco" : "Consegnato al banco", at: a.ritirato_at, who: a.ritirato_by_name || a.picker?.name },
    { key: "validato", label: "Controllato e validato", at: a.arrivato_at, who: a.accettato_by_name },
  ];

  return (
    <div className={compact ? "space-y-1.5" : "space-y-2"} data-testid={`timeline-${a.id}`}>
      {steps.map((s, i) => {
        const done = !!s.at;
        const prev = steps.slice(0, i).reverse().find((x) => x.at);
        const gap = done && prev ? durBetween(prev.at, s.at) : null;
        return (
          <div key={s.key} className="flex items-start gap-2.5" data-testid={`timeline-step-${s.key}`}>
            <div className="flex flex-col items-center pt-0.5">
              <div className={`w-2.5 h-2.5 rounded-full ${done ? "bg-emerald-400" : "bg-slate-600"}`} />
              {i < steps.length - 1 && <div className={`w-px flex-1 min-h-[16px] ${done ? "bg-emerald-400/40" : "bg-slate-700"}`} />}
            </div>
            <div className="flex-1 min-w-0 pb-1">
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className={`text-sm ${done ? "text-slate-100" : "text-slate-500"}`}>{s.label}</span>
                {done ? (
                  <span className="text-xs font-mono-plex text-slate-400 flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {fmt(s.at)}
                  </span>
                ) : (
                  <span className="text-[10px] uppercase tracking-wider text-slate-600">in attesa</span>
                )}
              </div>
              <div className="flex items-center gap-2 text-xs text-slate-500">
                {s.who && <span>{s.who}</span>}
                {gap && <span className="text-amber-400/80">· +{gap}</span>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
